import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetRecipientList({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/recipient/list", //?order_by=created_on&order_dir=desc
        params: {
          page: (list && list.page) || 0,
          recipient_name: list && list.search ? "*" + list.search  + "*" : '',
          per_page: (list && list.perPage) || 10,
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  GetRecipientListSmsCenter({ commit }) {
    return new Promise(resolve => {
      axios({
        url: "/recipient/list",
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  GetRecipient({ commit }, recipient_uuid) {
    return new Promise(resolve => {
      axios({
        url: "/recipient/" + recipient_uuid,
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  DeleteRecipient({ commit }, recipient_uuid) {
    return new Promise(resolve => {
      axios({
        url: "/recipient/" + recipient_uuid,
        method: "DELETE"
      }).then(res => {
        console.log(res);
        resolve(res.data.payload);
      });
    });
  },
  EditRecipient({ commit }, recipient) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/recipient/" + recipient.recipient_uuid,
        data: recipient.recipient,
        method: "PATCH"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  PostRecipient({ commit }, recipient) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/recipient",
        data: recipient,
        method: "POST"
      })
        .then(res => {
          resolve(res.data.payload);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  UploadRecipientFile({ commit }, form) {
      return axios.post("/recipient/import", form)
  }
};

// mutations
const mutations = {};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
